import * as Yup from "yup";

const BranchInfoSchema = Yup.object({
  branch_name: Yup.string().required("INPUT.VALIDATION.BRANCHINFO.BRANCHNAME"),
  type: Yup.string().required("INPUT.VALIDATION.BRANCHINFO.TYPE"),
  phone_number: Yup.string()
    .nullable()
    .required("INPUT.VALIDATION.BRANCHINFO.PHONENUMBER"),
  // address:Yup.object(),
  address: Yup.object({
    regionId: Yup.string().required("INPUT.VALIDATION.REGION"),
    address_line_1: Yup.string().required(
      "INPUT.VALIDATION.ADDRESS.ADDRESS.LINE1",
    ),
    city: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.CITY"),
    postal: Yup.string().required("INPUT.VALIDATION.ADDRESS.ADDRESS.ZIPCODE"),
  }),
});
export default BranchInfoSchema;
